/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type VideoError = {
  httpStatus: number;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type VideoLimitInfo = {
  portalId: number;
  limitType: string;
  quantityAllowed: number;
  quantityUsed: number;
  lastWentOverLimitTimestamp: number;
  daysRemainingToDowngrade?: number;
};

export type MuxStatus =
  | 'preparing'
  | 'ready'
  | 'errored'
  | 'not_sent_to_mux'
  | 'mux_ingestion_task_enqueued'
  | unhandledEnumCase;

export type PreviewPlayerRequest = { videoId: number; parentDomain?: string };

export type PreviewPlayerResponse = {
  video: ConsolidatedVideoEntity;
  gates: Default<string[]>;
  parentDomainIsCms?: boolean;
};

export type ConsolidatedVideoEntities = {
  consolidatedVideoEntities: Default<ConsolidatedVideoEntity[]>;
};

export type ConsolidatedVideoEntity = {
  portalId: number;
  crmObjectId: number;
  sourceFileId: number;
  sourceFileUrl: string;
  sourceFileSize: number;
  videoId: number;
  duration?: number;
  title: string;
  seoTitle?: string;
  primaryPlaybackId?: string;
  height?: number;
  width?: number;
  sourceFileBitrate?: number;
  sourceFileFrameRate?: string;
  posterUrl?: string;
  transcodingState?: MuxStatus;
  createdAt: number;
  updatedAt: number;
  deletedAt: number;
  isEmbeddable?: boolean;
  hasShareKey?: boolean;
  muxUpdatedAt: number;
  thumbnailSourceFileId?: number;
  thumbnailUrl?: string;
  thumbnailSourceMilliseconds?: number;
  subtitleLanguageCodes: Default<string[]>;
  mp4FileUrl?: string;
  tags: Default<string[]>;
  description?: string;
  folderId?: number;
  folderPath?: string;
  chapters?: SeoChapters;
  sourceFileLanguageCode?: string;
  sourceFileStreams: Default<FileMetadataStream[]>;
  sourceFileAllowsAnonymousAccess?: boolean;
  visibility?: VideoVisibility;
  videoType?: VideoType;
  videoOrigin?: VideoOrigin;
  thirdPartyOriginAppId?: number;
  videoAttributes: Default<VideoAttribute[]>;
  fileExtension?: string;
  muxAssetId?: string;
};

export type CrmObjectIdRequest = { crmObjectId: number };

export type CrmVideoResponse = {
  portalId: number;
  crmObjectId: number;
  sourceFileId: number;
  videoId: number;
  createdAt: number;
  updatedAt: number;
  deletedAt: number;
  title?: string;
  fileUrl?: string;
  duration?: number;
  height?: number;
  width?: number;
  folderId?: number;
  folderPath?: string;
  isEmbeddable?: boolean;
  hasShareKey?: boolean;
  subtitleLanguageCodes: Default<string[]>;
  mp4FileUrl?: string;
  muxUpdatedAt?: number;
  thumbnailUrl?: string;
  thumbnailSourceFileId?: number;
  thumbnailSourceMilliseconds?: number;
  posterUrl?: string;
  primaryPlaybackId?: string;
  transcodingState?: MuxStatus;
  chapters?: SeoChapters;
  videoType?: VideoType;
  videoOrigin?: VideoOrigin;
  videoAttributes: Default<VideoAttribute[]>;
  thirdPartyOriginAppId?: number;
  fileExtension?: string;
  muxAssetId?: string;
};

export type EmptyResponse = {};

export type FileIdRequest = { sourceFileId: number };

export type FileIdsRequest = { sourceFileIds: Default<number[]> };

export type FileMetadataStream = {
  codecName?: string;
  codecLongName?: string;
  codecType: CodecType;
  profile?: string;
  codecTimeBase?: string;
  width: number;
  height: number;
  duration: number;
  bitrate: number;
  startTime: number;
  displayAspectRatio?: string;
  sampleAspectRatio?: string;
  timeBase?: string;
  frameRate?: string;
  avgFrameRate?: string;
  sampleRate: number;
  channels: number;
  rotation: number;
  tags: Default<Record<string, string>>;
};

export type PagedConsolidatedVideoEntities = {
  total: number;
  results: Default<ConsolidatedVideoEntity[]>;
  hasMore: boolean;
  offset: number;
};

export type PagedFileIdsRequest = {
  sourceFileIds: Default<number[]>;
  pageLength: Default<number>;
  offset: number;
};

export type SetThumbnailRequest = {
  fileId: number;
  thumbnailFileId: number;
  thumbnailTimestampMillis?: number;
};

export type UpdateVideoEmbeddabilityRequest = {
  isEmbeddable: boolean;
  sourceFileId: number;
};

export type UpdateVideoRequest = {
  fileId: number;
  fileName?: string;
  seoTitle?: string;
  description?: string;
  tags?: string[];
  thumbnailSourceFileId?: number;
  thumbnailSourceMilliseconds?: number;
  isEmbeddable?: boolean;
  chapters?: SeoChapters;
  videoAttributes?: VideoAttribute[];
  posterUrl?: string;
  changeSource?: string;
  clearChapters: Default<boolean>;
};

export type UpdateVideoVisibilityRequest = {
  visibility: VideoVisibility;
  sourceFileId: number;
};

export type VideoAttribute =
  | 'DUBBED'
  | 'TRANSLATED'
  | 'AI_SUGGESTED'
  | 'EDITED'
  | 'TIKTOK_AUDIO_AVAILABLE'
  | unhandledEnumCase;

export type VideoIdRequest = { videoId: number };

export type VideoIdsRequest = { videoIds: Default<number[]> };

export type VideoOrigin =
  | 'UPLOAD'
  | 'THIRD_PARTY'
  | 'CLIP_EDITOR'
  | 'CAPTURE'
  | unhandledEnumCase;

export type VideoVisibility =
  | 'PUBLIC'
  | 'PUBLIC_NO_INDEX'
  | 'PRIVATE'
  | 'ANYONE_WITH_LINK'
  | unhandledEnumCase;

export type CodecType = 'AUDIO' | 'VIDEO' | unhandledEnumCase;

export type Chapter = { startTime: number; title: string };

export type SeoChapters = { items: Default<Chapter[]> };

export type ResolveShareKeyRequest = { shareKey: string };

export type ShareKeyRequest = { fileId: number };

export type ShareKeyResponse = { shareKey: string; fileId: number };

export type TranscriptRequest = { videoId: number };

export type TranscriptResponse = {
  transcripts: Default<Record<string, string>>;
};

export type VideoType = 'ORIGINAL_VIDEO' | 'CLIP' | unhandledEnumCase;

export type GetVideoByVideoIdRequestType = Requestify<VideoIdRequest>;
export type GetVideoByVideoIdResponseType = ConsolidatedVideoEntity;
export type GetVideoByVideoIdErrorType = VideoError & HubspotMetadata;
export const getVideoByVideoIdRpc: ChirpAvroRpcDetails<
  GetVideoByVideoIdRequestType,
  GetVideoByVideoIdResponseType,
  GetVideoByVideoIdErrorType,
  false
> = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'getVideoByVideoId',
  auth: 'app',
  fingerprint: 'BsBxm9pdnfHRmRJkYrQtTCsLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetCrmVideoByVideoIdRequestType = Requestify<VideoIdRequest>;
export type GetCrmVideoByVideoIdResponseType = CrmVideoResponse;
export type GetCrmVideoByVideoIdErrorType = VideoError & HubspotMetadata;
export const getCrmVideoByVideoIdRpc: ChirpAvroRpcDetails<
  GetCrmVideoByVideoIdRequestType,
  GetCrmVideoByVideoIdResponseType,
  GetCrmVideoByVideoIdErrorType,
  false
> = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'getCrmVideoByVideoId',
  auth: 'app',
  fingerprint: 'BsBxm9pdnfH1TwFLzVruTisLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetVideosByVideoIdsRequestType = Requestify<VideoIdsRequest>;
export type GetVideosByVideoIdsResponseType = ConsolidatedVideoEntities;
export type GetVideosByVideoIdsErrorType = VideoError & HubspotMetadata;
export const getVideosByVideoIdsRpc: ChirpAvroRpcDetails<
  GetVideosByVideoIdsRequestType,
  GetVideosByVideoIdsResponseType,
  GetVideosByVideoIdsErrorType,
  false
> = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'getVideosByVideoIds',
  auth: 'app',
  fingerprint: 'TCtE7lZ6pEYd1nhSErGuQCsLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetVideoByFileIdRequestType = Requestify<FileIdRequest>;
export type GetVideoByFileIdResponseType = ConsolidatedVideoEntity;
export type GetVideoByFileIdErrorType = VideoError & HubspotMetadata;
export const getVideoByFileIdRpc: ChirpAvroRpcDetails<
  GetVideoByFileIdRequestType,
  GetVideoByFileIdResponseType,
  GetVideoByFileIdErrorType,
  false
> = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'getVideoByFileId',
  auth: 'app',
  fingerprint: 'ATWAZeIns-nRmRJkYrQtTCsLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetVideosByFileIdsBulkRequestType = Requestify<FileIdsRequest>;
export type GetVideosByFileIdsBulkResponseType = ConsolidatedVideoEntities;
export type GetVideosByFileIdsBulkErrorType = VideoError & HubspotMetadata;
export const getVideosByFileIdsBulkRpc: ChirpAvroRpcDetails<
  GetVideosByFileIdsBulkRequestType,
  GetVideosByFileIdsBulkResponseType,
  GetVideosByFileIdsBulkErrorType,
  false
> = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'getVideosByFileIdsBulk',
  auth: 'app',
  fingerprint: 'PtmECGKy_gwd1nhSErGuQCsLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetVideosByFileIdsPagedRequestType =
  Requestify<PagedFileIdsRequest>;
export type GetVideosByFileIdsPagedResponseType =
  PagedConsolidatedVideoEntities;
export type GetVideosByFileIdsPagedErrorType = VideoError & HubspotMetadata;
export const getVideosByFileIdsPagedRpc: ChirpAvroRpcDetails<
  GetVideosByFileIdsPagedRequestType,
  GetVideosByFileIdsPagedResponseType,
  GetVideosByFileIdsPagedErrorType,
  false
> = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'getVideosByFileIdsPaged',
  auth: 'app',
  fingerprint: 'xrkFsssajwUksR7XIuYqWysLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetVideoByCrmIdRequestType = Requestify<CrmObjectIdRequest>;
export type GetVideoByCrmIdResponseType = ConsolidatedVideoEntity;
export type GetVideoByCrmIdErrorType = VideoError & HubspotMetadata;
export const getVideoByCrmIdRpc: ChirpAvroRpcDetails<
  GetVideoByCrmIdRequestType,
  GetVideoByCrmIdResponseType,
  GetVideoByCrmIdErrorType,
  false
> = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'getVideoByCrmId',
  auth: 'app',
  fingerprint: 'srIQeYJROEbRmRJkYrQtTCsLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type SoftDeleteVideoByFileIdRequestType = Requestify<FileIdRequest>;
export type SoftDeleteVideoByFileIdResponseType = EmptyResponse;
export type SoftDeleteVideoByFileIdErrorType = VideoError & HubspotMetadata;
export const softDeleteVideoByFileIdRpc: ChirpAvroRpcDetails<
  SoftDeleteVideoByFileIdRequestType,
  SoftDeleteVideoByFileIdResponseType,
  SoftDeleteVideoByFileIdErrorType,
  false
> = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'softDeleteVideoByFileId',
  auth: 'app',
  fingerprint: 'ATWAZeIns-m0zRsL6R_-pysLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type SoftDeleteVideosByFileIdsBulkRequestType =
  Requestify<FileIdsRequest>;
export type SoftDeleteVideosByFileIdsBulkResponseType = EmptyResponse;
export type SoftDeleteVideosByFileIdsBulkErrorType = VideoError &
  HubspotMetadata;
export const softDeleteVideosByFileIdsBulkRpc: ChirpAvroRpcDetails<
  SoftDeleteVideosByFileIdsBulkRequestType,
  SoftDeleteVideosByFileIdsBulkResponseType,
  SoftDeleteVideosByFileIdsBulkErrorType,
  false
> = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'softDeleteVideosByFileIdsBulk',
  auth: 'app',
  fingerprint: 'PtmECGKy_gy0zRsL6R_-pysLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type HardDeleteVideoByFileIdRequestType = Requestify<FileIdRequest>;
export type HardDeleteVideoByFileIdResponseType = EmptyResponse;
export type HardDeleteVideoByFileIdErrorType = VideoError & HubspotMetadata;
export const hardDeleteVideoByFileIdRpc: ChirpAvroRpcDetails<
  HardDeleteVideoByFileIdRequestType,
  HardDeleteVideoByFileIdResponseType,
  HardDeleteVideoByFileIdErrorType,
  false
> = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'hardDeleteVideoByFileId',
  auth: 'app',
  fingerprint: 'ATWAZeIns-m0zRsL6R_-pysLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UpdateVideoByFileIdRequestType = Requestify<UpdateVideoRequest>;
export type UpdateVideoByFileIdResponseType = ConsolidatedVideoEntity;
export type UpdateVideoByFileIdErrorType = VideoError & HubspotMetadata;
export const updateVideoByFileIdRpc: ChirpAvroRpcDetails<
  UpdateVideoByFileIdRequestType,
  UpdateVideoByFileIdResponseType,
  UpdateVideoByFileIdErrorType,
  false
> = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'updateVideoByFileId',
  auth: 'app',
  fingerprint: 'TKZWR_XohOHRmRJkYrQtTCsLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type SetThumbnailRequestType = Requestify<SetThumbnailRequest>;
export type SetThumbnailResponseType = ConsolidatedVideoEntity;
export type SetThumbnailErrorType = VideoError & HubspotMetadata;
export const setThumbnailRpc: ChirpAvroRpcDetails<
  SetThumbnailRequestType,
  SetThumbnailResponseType,
  SetThumbnailErrorType,
  false
> = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'setThumbnail',
  auth: 'app',
  fingerprint: 'obPSK1r8C0zRmRJkYrQtTCsLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UpdateVideoEmbeddabilityRequestType =
  Requestify<UpdateVideoEmbeddabilityRequest>;
export type UpdateVideoEmbeddabilityResponseType = ConsolidatedVideoEntity;
export type UpdateVideoEmbeddabilityErrorType = VideoError & HubspotMetadata;
export const updateVideoEmbeddabilityRpc: ChirpAvroRpcDetails<
  UpdateVideoEmbeddabilityRequestType,
  UpdateVideoEmbeddabilityResponseType,
  UpdateVideoEmbeddabilityErrorType,
  false
> = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'updateVideoEmbeddability',
  auth: 'app',
  fingerprint: 'QeTw4qLrrTPRmRJkYrQtTCsLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UpdateVideoVisibilityRequestType =
  Requestify<UpdateVideoVisibilityRequest>;
export type UpdateVideoVisibilityResponseType = ConsolidatedVideoEntity;
export type UpdateVideoVisibilityErrorType = VideoError & HubspotMetadata;
export const updateVideoVisibilityRpc: ChirpAvroRpcDetails<
  UpdateVideoVisibilityRequestType,
  UpdateVideoVisibilityResponseType,
  UpdateVideoVisibilityErrorType,
  false
> = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'updateVideoVisibility',
  auth: 'app',
  fingerprint: 'fdvXvRhNl6DRmRJkYrQtTCsLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetVideoLimitInfoResponseType = VideoLimitInfo;
export type GetVideoLimitInfoErrorType = VideoError & HubspotMetadata;
export const getVideoLimitInfoRpc: ChirpAvroRpcDetails<
  undefined,
  GetVideoLimitInfoResponseType,
  GetVideoLimitInfoErrorType,
  false
> = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'getVideoLimitInfo',
  auth: 'app',
  fingerprint: 'AAAAAAAAAADvzvuCIdRzXSsLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetVideoLimitInfoForDisplayResponseType = VideoLimitInfo;
export type GetVideoLimitInfoForDisplayErrorType = VideoError & HubspotMetadata;
export const getVideoLimitInfoForDisplayRpc: ChirpAvroRpcDetails<
  undefined,
  GetVideoLimitInfoForDisplayResponseType,
  GetVideoLimitInfoForDisplayErrorType,
  false
> = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'getVideoLimitInfoForDisplay',
  auth: 'app',
  fingerprint: 'AAAAAAAAAADvzvuCIdRzXSsLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetOrCreateShareKeyRequestType = Requestify<ShareKeyRequest>;
export type GetOrCreateShareKeyResponseType = ShareKeyResponse;
export type GetOrCreateShareKeyErrorType = VideoError & HubspotMetadata;
export const getOrCreateShareKeyRpc: ChirpAvroRpcDetails<
  GetOrCreateShareKeyRequestType,
  GetOrCreateShareKeyResponseType,
  GetOrCreateShareKeyErrorType,
  false
> = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'getOrCreateShareKey',
  auth: 'app',
  fingerprint: 'cO_e4JOmF61VXyZd6ICrtCsLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type ResolveShareKeyRequestType = Requestify<ResolveShareKeyRequest>;
export type ResolveShareKeyResponseType = ShareKeyResponse;
export type ResolveShareKeyErrorType = VideoError & HubspotMetadata;
export const resolveShareKeyRpc: ChirpAvroRpcDetails<
  ResolveShareKeyRequestType,
  ResolveShareKeyResponseType,
  ResolveShareKeyErrorType,
  false
> = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'resolveShareKey',
  auth: 'app',
  fingerprint: 'vi_TH49Wy59VXyZd6ICrtCsLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetSignedTranscriptsRequestType = Requestify<TranscriptRequest>;
export type GetSignedTranscriptsResponseType = TranscriptResponse;
export type GetSignedTranscriptsErrorType = VideoError & HubspotMetadata;
export const getSignedTranscriptsRpc: ChirpAvroRpcDetails<
  GetSignedTranscriptsRequestType,
  GetSignedTranscriptsResponseType,
  GetSignedTranscriptsErrorType,
  false
> = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'getSignedTranscripts',
  auth: 'app',
  fingerprint: 'S7OsslMCJMST9V1Krju9RCsLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetPreviewPlayerRequestType = Requestify<PreviewPlayerRequest>;
export type GetPreviewPlayerResponseType = PreviewPlayerResponse;
export type GetPreviewPlayerErrorType = VideoError & HubspotMetadata;
export const getPreviewPlayerRpc: ChirpAvroRpcDetails<
  GetPreviewPlayerRequestType,
  GetPreviewPlayerResponseType,
  GetPreviewPlayerErrorType,
  false
> = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoRpc',
  rpcName: 'getPreviewPlayer',
  auth: 'app',
  fingerprint: 'P5_qusteyqQFrGtjMucrfSsLz2OgadI9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
